module.exports = __webpack_public_path__ + "img/bg-dots.1507dc0a.svg";